document.addEventListener('alpine:init', () => {
    Alpine.data('cartDrawer', ({ sectionId }) => ({
        sectionId: sectionId || '',
        isOpen: false,
        classes: {
            active: 'm-active',
        },

        /**
         * Initializes the cart drawer.
         * @returns {void}
         */
        init() {
            console.log('Cart drawer initialized');
            // ctr:cart:added fires after post-processors (e.g. GWP gifts) and
            // after the display snapshot is released, so the drawer opens with
            // the final cart contents.
            this.onCartAdded = () => this.open();
            this.onThemeProductAdded = () => this.open();

            document.addEventListener('ctr:cart:added', this.onCartAdded);
            document.addEventListener('theme:product:added', this.onThemeProductAdded);
        },

        /**
         * Destroys the cart drawer.
         * @returns {void}
         */
        destroy() {
            document.removeEventListener('ctr:cart:added', this.onCartAdded);
            document.removeEventListener('theme:product:added', this.onThemeProductAdded);
        },

        /**
         * Toggles the cart drawer.
         * @returns {void}
         */
        toggleCartDrawer() {
            this.isOpen ? this.close() : this.open();
        },

        /**
         * Opens the cart drawer.
         * @returns {void}
         */
        open() {
            this.isOpen = true;
        },

        /**
         * Closes the cart drawer.
         * @returns {void}
         */
        close() {
            this.isOpen = false;
        },
    }));
});